"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationEventType = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
let NotificationEventType = class NotificationEventType {
};
exports.NotificationEventType = NotificationEventType;
tslib_1.__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)({ name: "id", type: "int", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], NotificationEventType.prototype, "id", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ unique: true }),
    tslib_1.__metadata("design:type", String)
], NotificationEventType.prototype, "name", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ nullable: true }),
    tslib_1.__metadata("design:type", String)
], NotificationEventType.prototype, "description", void 0);
exports.NotificationEventType = NotificationEventType = tslib_1.__decorate([
    (0, typeorm_1.Entity)('notification_event_type')
], NotificationEventType);
